import React from 'react';

import { IAction } from '../../../types/action';
import { INotification } from '../../../types/notification';

import { Icons } from '../../../data/Assets';

import { SVGIcon } from '../../wrappers/SVGIcon';

interface INotificationSidebarProps {
    handleActionAccordion: () => void;
    handleNotificationAccordion: () => void;
    handleAddAction: () => void;
    handleAddNotification: () => void;
    isActionOpen: boolean;
    isNotificationOpen: boolean;
    isAddAction: boolean;
    isAddNotification: boolean;
    currentOption: number[];
    setCurrentOption: React.Dispatch<React.SetStateAction<number[]>>;
    actions: IAction[];
    notifications: INotification[];
}

export const NotificationSidebar = ({ handleActionAccordion, handleNotificationAccordion, handleAddAction, handleAddNotification, isActionOpen, isNotificationOpen, isAddAction, isAddNotification, currentOption, setCurrentOption, actions, notifications }: INotificationSidebarProps) => {
    return (
        <div className='side_bar'>
            <div className='options'>
                <button disabled={isAddAction || isAddNotification} onClick={handleAddAction}><SVGIcon src={Icons.Plus} />Add Action</button>
                <button disabled={isAddAction || isAddNotification} onClick={handleAddNotification}><SVGIcon src={Icons.Plus} />Add Notification</button>
            </div>

            <div className='options_tree'>
                <div id='actions' className={`category cont ${currentOption.length === 1 && currentOption[0] === 0 ? 'selected' : ''} ${isActionOpen ? 'rotate_svg' : ''}`} onClick={handleActionAccordion}><SVGIcon src={Icons.TriangleFill} /> <p>Actions</p></div>

                {isAddAction && <div id="new_action" className={`program cont selected`}><SVGIcon src={Icons.PointFill} /> <p>New Action</p></div>}

                {isActionOpen && actions.map((action, index) => (<div key={index} className={`program cont ${currentOption.length === 2 && currentOption[0] === 0 && currentOption[1] === index ? 'selected' : ''}`} onClick={() => setCurrentOption([0, index])}> <SVGIcon src={Icons.PointFill} /><p>{action.name}</p></div>))}

                {isActionOpen && actions.length === 0 && <div id="empty_action" className={`program cont`}><p>No actions found. Please add actions</p></div>}

                <div id='notifications' className={`category cont ${currentOption.length === 1 && currentOption[0] === 1 ? 'selected' : ''} ${isNotificationOpen ? 'rotate_svg' : ''}`} onClick={handleNotificationAccordion}><SVGIcon src={Icons.TriangleFill} /> <p>Notifications</p></div>

                {isAddNotification && <div id="new_notification" className={`program cont selected`}><SVGIcon src={Icons.PointFill} /> <p>New Notification</p></div>}

                {isNotificationOpen && notifications.map((notification, index) => (<div key={index} className={`program cont ${currentOption.length === 2 && currentOption[0] === 1 && currentOption[1] === index ? 'selected' : ''}`} onClick={() => setCurrentOption([1, index])}> <SVGIcon src={Icons.PointFill} /><p>{notification.title}</p></div>))}

                {isNotificationOpen && notifications.length === 0 && <div id="empty_notification" className={`program cont`}><p>No notifications found. Please add notifications</p></div>}
            </div>
        </div>
    )
}
